/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorneDto } from './BorneDto';
import {
    BorneDtoFromJSON,
    BorneDtoFromJSONTyped,
    BorneDtoToJSON,
    BorneDtoToJSONTyped,
} from './BorneDto';

/**
 * Garantie du tunnel telle que listée dans l'onglet Garanties.
 * @export
 * @interface GarantieTunnelListItemDto
 */
export interface GarantieTunnelListItemDto {
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelListItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelListItemDto
     */
    garantieTunnelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelListItemDto
     */
    garantieId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GarantieTunnelListItemDto
     */
    isRequired?: boolean;
    /**
     * Faux = garantie retirée du tunnel de souscription et de la tarification, sans suppression.
     * @type {boolean}
     * @memberof GarantieTunnelListItemDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelListItemDto
     */
    designation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelListItemDto
     */
    descriptionCourte?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelListItemDto
     */
    descriptionLongue?: string | null;
    /**
     * Au moins un texte de franchise ou de plafond des documents est renseigné.
     * @type {boolean}
     * @memberof GarantieTunnelListItemDto
     */
    aDetailsDocuments?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GarantieTunnelListItemDto
     */
    iconeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GarantieTunnelListItemDto
     */
    ordreAffichage?: number;
    /**
     * 
     * @type {Array<BorneDto>}
     * @memberof GarantieTunnelListItemDto
     */
    franchises?: Array<BorneDto> | null;
    /**
     * 
     * @type {Array<BorneDto>}
     * @memberof GarantieTunnelListItemDto
     */
    plafonds?: Array<BorneDto> | null;
}

/**
 * Check if a given object implements the GarantieTunnelListItemDto interface.
 */
export function instanceOfGarantieTunnelListItemDto(value: object): value is GarantieTunnelListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GarantieTunnelListItemDtoFromJSON(json: any): GarantieTunnelListItemDto {
    return GarantieTunnelListItemDtoFromJSONTyped(json, false);
}

export function GarantieTunnelListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GarantieTunnelListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'garantieTunnelId': json['garantieTunnelId'] == null ? undefined : json['garantieTunnelId'],
        'garantieId': json['garantieId'] == null ? undefined : json['garantieId'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'descriptionCourte': json['descriptionCourte'] == null ? undefined : json['descriptionCourte'],
        'descriptionLongue': json['descriptionLongue'] == null ? undefined : json['descriptionLongue'],
        'aDetailsDocuments': json['aDetailsDocuments'] == null ? undefined : json['aDetailsDocuments'],
        'iconeId': json['iconeId'] == null ? undefined : json['iconeId'],
        'ordreAffichage': json['ordreAffichage'] == null ? undefined : json['ordreAffichage'],
        'franchises': json['franchises'] == null ? undefined : ((json['franchises'] as Array<any>).map(BorneDtoFromJSON)),
        'plafonds': json['plafonds'] == null ? undefined : ((json['plafonds'] as Array<any>).map(BorneDtoFromJSON)),
    };
}

export function GarantieTunnelListItemDtoToJSON(json: any): GarantieTunnelListItemDto {
    return GarantieTunnelListItemDtoToJSONTyped(json, false);
}

export function GarantieTunnelListItemDtoToJSONTyped(value?: GarantieTunnelListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'garantieTunnelId': value['garantieTunnelId'],
        'garantieId': value['garantieId'],
        'isRequired': value['isRequired'],
        'isActive': value['isActive'],
        'designation': value['designation'],
        'descriptionCourte': value['descriptionCourte'],
        'descriptionLongue': value['descriptionLongue'],
        'aDetailsDocuments': value['aDetailsDocuments'],
        'iconeId': value['iconeId'],
        'ordreAffichage': value['ordreAffichage'],
        'franchises': value['franchises'] == null ? undefined : ((value['franchises'] as Array<any>).map(BorneDtoToJSON)),
        'plafonds': value['plafonds'] == null ? undefined : ((value['plafonds'] as Array<any>).map(BorneDtoToJSON)),
    };
}

